import { Box, Typography } from "@material-ui/core";
import TagsForm from "../Components/TagsForm";
import { formatRowToData } from "../";


export default function EditMovieTagPage({disabled, ...props}) {

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Movies &gt; Edit Movie Tags
        </Typography>
      </Box>
        <TagsForm
          description="Edit Movie Tags"
          submitBtnTxt="Save Changes"
          gridSize={6}
          upperBtnGroupSize="50%"
          history={props.history}
          formatRowToData={formatRowToData}
          disabled={disabled}
        />
    </>
  );
}
